export default class WindsogCalculator {
  constructor(params) {
    this.params = params;
    //Variablen aus Form
    this.windzone = params["windzone"];
    this.geoLage = params["standort"];
    this.standHoehe = params["standorthoehe"];
    this.gebHoehe = params["gebaeudehoehe"];

    this.exponiert = params["lagexponiert"];
    this.geschlossen = params["geschlossen"];
    this.deckunterlage = params["deckunterlage"];
    this.lattung = params["lattung"];
    this.dachform = params["dachform"];
    this.dachneigung = params["dachneigung"];
    this.walmneigung = params["walmneigung"];
    this.laengeTraufe = params["trauflaenge"];
    this.laengeKurzeTraufeWalm = params["walmtrauflaenge"];
    this.laengeGiebel = params["giebellaenge"];

    this.dachziegelId = params["pfanne"];

    this.Dachziegel = params["dachpfannenObject"];
    this.failed = false;
    this.failedMessage = "";
  }

  /**
   * Herzstück des Konfigurators, vereint alle Berechnungen und gibt JSON Objekt zurück
   */
  calculate() {
    var failed = false;
    var failedMessage = "";

    // Result mit Eingaben füllen
    // Das Result Array wird später alle relevanten Parameter beinhalten
    var result = {};

    // Wenn Standorthoehe > 800 dann gilt: Faktor = 0,2 + standhoehe/1000 !AB 1100 Meter ist ein Fachmann notwendig
    var erhoehungsFaktor = 0;
    if (this.standHoehe > 800 && this.standHoehe <= 1100) {
      erhoehungsFaktor = 0.2 + this.standHoehe / 1000;
    } else if (!(this.standHoehe <= 800)) {
      return this.getErrorMessage("Unerlaubte Eingabe bei Standorthöhe!");
    }

    // Berechnung Geschwindigkeitsdruck q(Ze)
    var geschDruck = this.calculateGeschwindigkeitsdruck(
      this.windzone,
      this.gebHoehe,
      this.geoLage
    );
    if (this.isArray(geschDruck)) {
      return this.getErrorMessage(geschDruck["message"]);
    } else {
      geschDruck += erhoehungsFaktor;
    }

    // Risikiofaktor ist immer gleich Yq = 1,35
    var risiko = 1.35;

    //Druckausgleich
    var druckausgleich = 0.5;
    if (
      this.geschlossen == "true" &&
      this.deckunterlage == "Geschlossene Deckunterlage"
    ) {
      druckausgleich = 0.5;
    } else if (
      this.geschlossen == "true" &&
      this.deckunterlage == "Unterspannung"
    ) {
      druckausgleich = 0.625;
    } else if (
      this.geschlossen == "false" &&
      this.deckunterlage != "Geschlossene Deckunterlage"
    ) {
      return this.getErrorMessage(
        "Unerlaubte Eingabe bei Geschlossenem Gebäude oder Deckunterlage "
      );
    }

    var aussendruckbeiwertKat1 = "";
    var aussendruckbeiwertKat1Walm = 0;
    var aussendruckbeiwertKat2 = "";
    var aussendruckbeiwertKat3 = "";
    var aussendruckbeiwertKat4 = "";
    var aussendruck = {};

    // Aussendruckbeiwerte
    if (this.dachform != "Pultdach") {
      aussendruckbeiwertKat1 = this.calculateAussendruckbeiwert(
        this.dachneigung,
        1
      );
      if (this.dachform == "Walmdach") {
        aussendruckbeiwertKat1Walm = this.calculateAussendruckbeiwert(
          this.walmneigung,
          1
        );
      }
      aussendruckbeiwertKat2 = this.calculateAussendruckbeiwert(
        this.dachneigung,
        2
      );
      aussendruckbeiwertKat3 = this.calculateAussendruckbeiwert(
        this.dachneigung,
        3
      );
      aussendruckbeiwertKat4 = this.calculateAussendruckbeiwert(
        this.dachneigung,
        4
      );
      aussendruck = {
        AussendruckbeiwertKatergorie1: aussendruckbeiwertKat1,
        AussendruckbeiwertKatergorie2: aussendruckbeiwertKat2,
        AussendruckbeiwertKatergorie3: aussendruckbeiwertKat3,
        AussendruckbeiwertKatergorie4: aussendruckbeiwertKat4,
        AussendruckbeiwertKatergorie1Walm: aussendruckbeiwertKat1Walm
      };

      if (this.isArray(aussendruckbeiwertKat1)) {
        return this.getErrorMessage(aussendruckbeiwertKat1["message"]);
      }
    } else {
      aussendruckbeiwertKat1 = this.calculateAussendruckbeiwertPult(
        this.dachneigung,
        1
      );
      aussendruckbeiwertKat2 = this.calculateAussendruckbeiwertPult(
        this.dachneigung,
        2
      );
      aussendruckbeiwertKat3 = this.calculateAussendruckbeiwertPult(
        this.dachneigung,
        3
      );
      aussendruckbeiwertKat4 = this.calculateAussendruckbeiwertPult(
        this.dachneigung,
        4
      );
      aussendruck = {
        AussendruckbeiwertKatergorie1: aussendruckbeiwertKat1,
        AussendruckbeiwertKatergorie2: aussendruckbeiwertKat2,
        AussendruckbeiwertKatergorie3: aussendruckbeiwertKat3,
        AussendruckbeiwertKatergorie4: aussendruckbeiwertKat4
      };
      if (this.isArray(aussendruckbeiwertKat1)) {
        return this.getErrorMessage(aussendruckbeiwertKat1["message"]);
      }
    }

    // Windlastparameter in Array für Result
    var windlastparameter = {
      Geschwindigkeitsdruck: geschDruck,
      Erhoehungsfaktor: erhoehungsFaktor,
      Druckausgleich: druckausgleich,
      Risikoaufschlag: risiko
    };

    // console.log(windlastparameter);
    // Result wird mit allen Parametern für Geschwindigkeitsdruck q(Ze) ergänzt
    Object.assign(result, windlastparameter, aussendruck);

    // Windlast(Wde) für verschiedene Dachbereiche
    var WindlastKat1 =
      risiko * aussendruckbeiwertKat1 * druckausgleich * geschDruck;
    var WindlastKat1Walm =
      risiko * aussendruckbeiwertKat1Walm * druckausgleich * geschDruck;
    var WindlastKat2 =
      risiko * aussendruckbeiwertKat2 * druckausgleich * geschDruck;
    var WindlastKat3 =
      risiko * aussendruckbeiwertKat3 * druckausgleich * geschDruck;
    var WindlastKat4 =
      risiko * aussendruckbeiwertKat4 * druckausgleich * geschDruck;
    var windlasten = {
      WindlastKategorie1: WindlastKat1,
      WindlastKategorie2: WindlastKat2,
      WindlastKategorie3: WindlastKat3,
      WindlastKategorie4: WindlastKat4,
      WindlastKategorie1Walm: WindlastKat1Walm
    };
    // console.log(windlasten);
    // Result wird mit Windlastberechnungen ergänzt
    Object.assign(result, windlasten);

    var dachflaechen;
    // Dachflaechenberechnung je nach Dachform
    if (this.dachform == "Satteldach") {
      // Dachflächenberechnung Satteldach
      dachflaechen = this.calculateDachflaechenSatteldach(
        this.dachneigung,
        this.laengeGiebel,
        this.laengeTraufe,
        this.gebHoehe
      );
      if (this.isArray(dachflaechen)) {
        Object.assign(result, dachflaechen);
      } else {
        return this.getErrorMessage(dachflaechen);
      }
    } else if (this.dachform == "Walmdach") {
      // Dachflächenberechnung Satteldach
      dachflaechen = this.calculateDachflaechenWalmdach(
        this.dachneigung,
        this.walmneigung,
        this.laengeKurzeTraufeWalm,
        this.laengeTraufe,
        this.gebHoehe
      );
      if (this.isArray(dachflaechen)) {
        Object.assign(result, dachflaechen);
      } else {
        return this.getErrorMessage(dachflaechen);
      }
    } else if (this.dachform == "Pultdach") {
      // Dachflächenberechnung Satteldach
      dachflaechen = this.calculateDachflaechenPultdach(
        this.dachneigung,
        this.laengeGiebel,
        this.laengeTraufe,
        this.gebHoehe
      );
      if (this.isArray(dachflaechen)) {
        Object.assign(result, dachflaechen);
      } else {
        return this.getErrorMessage(dachflaechen);
      }
    } else {
      return this.getErrorMessage("Unerlaubte Eingabe bei Dachform");
    }

    // Überprüfung auf Negativwerte in den Dachflaechen
    if (this.checkForNegatives(dachflaechen))
      return this.getErrorMessage(
        "Fehlerhafte Dachgeometrie oder zu kleine Werte! Bitte überprüfen Sie Ihre Eingaben für Dach und Gebäude!"
      );

    // Windsogensicherung wird berechnet (Welches Befestigungsmuster und Welcher Widerstand entsteht durch die Befestiegung)
    var eigenwiderstand = this.getEigenAbhebewiderstand(
      this.dachneigung,
      this.walmneigung,
      this.Dachziegel
    );
    var windsogsicherung = this.getWindsogsicherung(
      this.Dachziegel,
      eigenwiderstand,
      windlasten
    );
    // console.log(windsogsicherung);
    if (this.isArray(windsogsicherung)) Object.assign(result, windsogsicherung);
    else return this.getErrorMessage(windsogsicherung);

    var dachziegelwerte = this.getAnzahlDachziegelProKat(
      this.Dachziegel,
      dachflaechen
    );
    var klammerwerte = this.getAnzahlKlammernProKat(
      dachziegelwerte,
      windsogsicherung
    );
    Object.assign(result, dachziegelwerte, klammerwerte);

    //Fehlerarray für Result
    var fails = {
      Error: failed,
      Errormessage: failedMessage
    };
    Object.assign(result, fails);
    //console.log(result)
    return result;
  }

  /************************************************* ANNZAHL DACHZIEGEL + KLAMMERN *******************************************************/

  /**
   * @return Array
   *  Array mit Ziegellaenge, Breite, ProQm + Anzahl Ziegel pro Kategorie (für eine Dachseite)
   */
  getAnzahlDachziegelProKat(Dachziegel, dachflaechen) {
    var dachziegellaengecm = Dachziegel.decklaengemm / 10;
    var dachziegelbreitecm = Dachziegel.deckbreitemm / 10;
    var dachziegelproqm = 10000 / (dachziegelbreitecm * dachziegellaengecm);

    var dachziegelwerte = {
      Dachziegellaengecm: dachziegellaengecm,
      Dachziegelbreitecm: dachziegelbreitecm,
      Dachziegelproqm: dachziegelproqm
    };

    // Unterscheidung nach Walmdächern und Pult/Satteldach
    var werteKat1 = {};
    if (this.array_key_exists("FlaecheKat1Grat", dachflaechen)) {
      werteKat1 = {
        AnzahlZiegelKat1Grat: Math.ceil(
          dachflaechen.FlaecheKat1Grat * dachziegelproqm
        ),
        AnzahlZiegelKat1Walm: Math.ceil(
          dachflaechen.FlaecheKat1Walm * dachziegelproqm
        )
      };
    } else {
      werteKat1 = {
        AnzahlZiegelKat1: Math.ceil(dachflaechen.FlaecheKat1 * dachziegelproqm)
      };
    }
    var werteRest = {
      AnzahlZiegelKat2: Math.ceil(dachflaechen.FlaecheKat2 * dachziegelproqm),
      AnzahlZiegelKat3: Math.ceil(dachflaechen.FlaecheKat3 * dachziegelproqm),
      AnzahlZiegelKat4: Math.ceil(dachflaechen.FlaecheKat4 * dachziegelproqm)
    };

    return Object.assign(dachziegelwerte, werteKat1, werteRest);
  }

  /**
   * @return Array mit Anzahl der Klammern pro Dachkategorie (für eine Dachseite)
   */
  getAnzahlKlammernProKat(dachziegelwerte, windsogsicherung) {
    var result1 = {};
    var result2 = {};
    var result3 = {};
    var anzahlKlammernKat1Grat = 0;
    var anzahlKlammernKat1Walm = 0;
    var anzahlKlammernKat1 = 0;
    var anzahlKlammernKat2 = 0;
    var anzahlKlammernKat3 = 0;
    var anzahlKlammernKat4 = 0;
    var lat = "";
    if (this.lattung == "40 x 60 mm") lat = "40x60";
    if (this.array_key_exists("AnzahlZiegelKat1Grat", dachziegelwerte)) {
      switch (windsogsicherung["WindlastKategorie1Befestigung"]) {
        case "none":
          anzahlKlammernKat1Grat = 0;
          break;
        case "1:3":
          anzahlKlammernKat1Grat = dachziegelwerte.AnzahlZiegelKat1Grat / 3;
          break;
        case "1:2":
          anzahlKlammernKat1Grat = dachziegelwerte.AnzahlZiegelKat1Grat / 2;
          break;
        case "1:1":
          anzahlKlammernKat1Grat = dachziegelwerte.AnzahlZiegelKat1Grat;
          break;
        default:
          anzahlKlammernKat1Grat = null;
      }
      switch (windsogsicherung["WindlastKategorie1BefestigungWalm"]) {
        case "none":
          anzahlKlammernKat1Walm = 0;
          break;
        case "1:3":
          anzahlKlammernKat1Walm = dachziegelwerte.AnzahlZiegelKat1Walm / 3;
          break;
        case "1:2":
          anzahlKlammernKat1Walm = dachziegelwerte.AnzahlZiegelKat1Walm / 2;
          break;
        case "1:1":
          anzahlKlammernKat1Walm = dachziegelwerte.AnzahlZiegelKat1Walm;
          break;
        default:
          anzahlKlammernKat1Walm = null;
      }
    } else {
      switch (windsogsicherung["WindlastKategorie1Befestigung"]) {
        case "none":
          anzahlKlammernKat1 = 0;
          break;
        case "1:3":
          anzahlKlammernKat1 = dachziegelwerte.AnzahlZiegelKat1 / 3;
          break;
        case "1:2":
          anzahlKlammernKat1 = dachziegelwerte.AnzahlZiegelKat1 / 2;
          break;
        case "1:1":
          anzahlKlammernKat1 = dachziegelwerte.AnzahlZiegelKat1;
          break;
        default:
          anzahlKlammernKat1 = null;
      }
    }
    switch (windsogsicherung["WindlastKategorie2Befestigung"]) {
      case "none":
        anzahlKlammernKat2 = 0;
        break;
      case "1:3":
        anzahlKlammernKat2 = dachziegelwerte.AnzahlZiegelKat2 / 3;
        break;
      case "1:2":
        anzahlKlammernKat2 = dachziegelwerte.AnzahlZiegelKat2 / 2;
        break;
      case "1:1":
        anzahlKlammernKat2 = dachziegelwerte.AnzahlZiegelKat2;
        break;
      default:
        anzahlKlammernKat2 = null;
    }
    switch (windsogsicherung["WindlastKategorie3Befestigung"]) {
      case "none":
        anzahlKlammernKat3 = 0;
        break;
      case "1:3":
        anzahlKlammernKat3 = dachziegelwerte.AnzahlZiegelKat3 / 3;
        break;
      case "1:2":
        anzahlKlammernKat3 = dachziegelwerte.AnzahlZiegelKat3 / 2;
        break;
      case "1:1":
        anzahlKlammernKat3 = dachziegelwerte.AnzahlZiegelKat3;
        break;
      default:
        anzahlKlammernKat3 = null;
    }
    switch (windsogsicherung["WindlastKategorie4Befestigung"]) {
      case "none":
        anzahlKlammernKat4 = 0;
        break;
      case "1:3":
        anzahlKlammernKat4 = dachziegelwerte.AnzahlZiegelKat4 / 3;
        break;
      case "1:2":
        anzahlKlammernKat4 = dachziegelwerte.AnzahlZiegelKat4 / 2;
        break;
      case "1:1":
        anzahlKlammernKat4 = dachziegelwerte.AnzahlZiegelKat4;
        break;
      default:
        anzahlKlammernKat4 = null;
    }
    if (this.array_key_exists("AnzahlZiegelKat1Grat", dachziegelwerte))
      result1 = {
        AnzahlKlammernKat1Grat: Math.ceil(anzahlKlammernKat1Grat),
        AnzahlKlammernKat1Walm: Math.ceil(anzahlKlammernKat1Walm)
      };
    else
      result1 = {
        AnzahlKlammernKat1: Math.ceil(anzahlKlammernKat1)
      };

    result2 = {
      AnzahlKlammernKat2: Math.ceil(anzahlKlammernKat2),
      AnzahlKlammernKat3: Math.ceil(anzahlKlammernKat3),
      AnzahlKlammernKat4: Math.ceil(anzahlKlammernKat4)
    };
    if (this.array_key_exists("AnzahlZiegelKat1Grat", dachziegelwerte))
      result3 = {
        AnzahlKlammernGesamt: result1.AnzahlKlammernKat1Grat +
          result1.AnzahlKlammernKat1Walm +
          result2.AnzahlKlammernKat2 +
          result2.AnzahlKlammernKat3 +
          result2.AnzahlKlammernKat4
      };
    else
      result3 = {
        AnzahlKlammernGesamt: result1.AnzahlKlammernKat1 +
          result2.AnzahlKlammernKat2 +
          result2.AnzahlKlammernKat3 +
          result2.AnzahlKlammernKat4
      };

    return Object.assign(result1, result2, result3);
  }

  /************************************************* WINDSOGSICHERUNG *******************************************************/

  /**
   *  Berechnet den eigenAbhebewiderstand, der durch das Gewicht der Ziegel entsteht
   *  @return Array bei Walmdächern
   *  @return Float bei Pult, Satteldächern
   */
  getEigenAbhebewiderstand(dachneigung, walmneigung, Dachziegel) {
    if (walmneigung != "") {
      var widerstandTraufflaeche =
        Dachziegel.flaechengewicht * Math.cos(this.deg2rad(dachneigung));
      var widerstandWalmflaeche =
        Dachziegel.flaechengewicht * Math.cos(this.deg2rad(walmneigung));
      //console.log("Eigenabhebewiderstand Walm: "+widerstandTraufflaeche)
      return {
        widerstandTrauf: widerstandTraufflaeche,
        widerstandWalm: widerstandWalmflaeche
      };
    } else {
      var widerstand =
        Dachziegel.flaechengewicht * Math.cos(this.deg2rad(dachneigung));
      //console.log("gd: "+Dachziegel.flaechengewicht + " cos: "+ Math.cos(( Math.PI / 180)*dachneigung))
      // console.log("Eigenabhebewiderstand: " + widerstand);
      return widerstand;
    }
  }

  /**
   * Überprüft welche Sicherung (1:1, 1:2, 1:3, keine) benötigt wird und gibt die Ergebnisse je Dachbereich aus
   * @return Array mit Befestingsmaßnahmen je Dachbereich und Widerstand je Dachbereich
   */
  getWindsogsicherung(Dachziegel, eigenwiderstand, windlasten) {
    var failed = false;
    var failedMessage = "";
    var walmgleichtrauf = false;
    var result = {};
    var ziegelproqm =
      1000000 / (Dachziegel["decklaengemm"] * Dachziegel["deckbreitemm"]);

    // Für Walmdach muss für Walmdach eigenwiderstand separat geprüft werden
    if (this.isArray(eigenwiderstand)) {
      var widerstandTraufflaeche = eigenwiderstand["widerstandTrauf"];
      var widerstandWalmflaeche = eigenwiderstand["widerstandWalm"];

      result["EigenwiderstandTrauf"] = widerstandTraufflaeche;
      result["EigenwiderstandWalm"] = widerstandWalmflaeche;

      if (widerstandWalmflaeche + windlasten["WindlastKategorie1Walm"] >= 0) {
        result["WindlastKategorie1BefestigungWalm"] = "none";
        result["WindlastKategorie1WiderstandWalm"] = widerstandWalmflaeche;
        result["WindlastKategorie1WiderstandGesamt"] =
          widerstandWalmflaeche + windlasten["WindlastKategorie1Walm"];
      } else {
        walmgleichtrauf = true;
      }
    } else {
      // Falls kein Walmdach ist eigenwiderstand nur ein Wert
      widerstandTraufflaeche = eigenwiderstand;
      result["Eigenwiderstand"] = widerstandTraufflaeche;
    }

    // Berechnung des Widerstandes der einzelnen Verklammerungsarten
    var lat = "";
    if (this.lattung == "40 x 60 mm") lat = "40x60";
    var widerstand1zu1 =
      Math.ceil(ziegelproqm) * Dachziegel["messergebnis1zu1" + lat] +
      Dachziegel["flaechengewicht"] * Math.cos(this.deg2rad(this.dachneigung));
    var widerstand1zu2 =
      Math.ceil(ziegelproqm * (1 / 2)) * Dachziegel["messergebnis1zu2" + lat] +
      Dachziegel["flaechengewicht"] * Math.cos(this.deg2rad(this.dachneigung));
    var widerstand1zu3 =
      Math.ceil(ziegelproqm * (1 / 3)) * Dachziegel["messergebnis1zu3" + lat] +
      Dachziegel["flaechengewicht"] * Math.cos(this.deg2rad(this.dachneigung));

    // console.log(Math.ceil(ziegelproqm) * Dachziegel["messergebnis1zu3" + lat]);
    // console.log("Ziegelproqm: " + ziegelproqm);
    // console.log("Klammernproqm1zu1: " + Math.ceil(ziegelproqm));
    // console.log("Klammernproqm1zu2: " + Math.ceil(ziegelproqm * (1 / 2)));
    // console.log("Klammernproqm1zu3: " + Math.ceil(ziegelproqm * (1 / 3)));
    // console.log("Bemmesungslast 1:1: " + Dachziegel["messergebnis1zu1" + lat]);
    // console.log("Bemmesungslast 1:2: " + Dachziegel["messergebnis1zu2" + lat]);
    // console.log("Bemmesungslast 1:3: " + Dachziegel["messergebnis1zu3" + lat]);
    // console.log("Flächengewicht Lotrecht: " + Dachziegel["flaechengewicht"]);
    // console.log(
    //   "Flächengewicht Winkel: " +
    //     Dachziegel["flaechengewicht"] * Math.cos(this.deg2rad(this.dachneigung))
    // );

    // console.log(
    //   "1zu1: " +
    //     widerstand1zu1 +
    //     " 1zu2: " +
    //     widerstand1zu2 +
    //     " 1zu3: " +
    //     widerstand1zu3
    // );
    // Falls keine WErte für 1:2 oder 1:3 hinterlegt wird anders berechnet
    if (
      Dachziegel["messergebnis1zu2" + lat] == null ||
      Dachziegel["messergebnis1zu2" + lat] == 0
    ) {
      var widerstand1zu2 =
        Math.ceil(ziegelproqm * (1 / 2)) *
        Dachziegel["messergebnis1zu1" + lat] +
        Dachziegel["flaechengewicht"] *
        Math.cos(this.deg2rad(this.dachneigung));
    }
    if (
      Dachziegel["messergebnis1zu3" + lat] == null ||
      Dachziegel["messergebnis1zu3" + lat] == 0
    ) {
      var widerstand1zu3 =
        Dachziegel["flaechengewicht"] *
        Math.cos(this.deg2rad(this.dachneigung)) *
        1.3;
    }

    for (const [k, v] of Object.entries(windlasten)) {
      //console.log(widerstandTraufflaeche + " " +k + " " +v);

      if (widerstandTraufflaeche + v >= 0) {
        result[k + "Befestigung"] = "none";
        result[k + "WiderstandKlammer"] = widerstandTraufflaeche;
        result[k + "WiderstandGesamt"] = widerstandTraufflaeche + v;
      } else if (widerstand1zu3 / 1000 + v >= 0) {
        result[k + "Befestigung"] = "1:3";
        result[k + "WiderstandKlammer"] = widerstand1zu3;
        result[k + "WiderstandGesamt"] = widerstand1zu3 / 1000 + v;
      } else if (widerstand1zu2 / 1000 + v >= 0) {
        result[k + "Befestigung"] = "1:2";
        result[k + "WiderstandKlammer"] = widerstand1zu2;
        result[k + "WiderstandGesamt"] = widerstand1zu2 / 1000 + v;
      } else if (widerstand1zu1 / 1000 + v >= 0) {
        result[k + "Befestigung"] = "1:1";
        result[k + "WiderstandKlammer"] = widerstand1zu1;
        result[k + "WiderstandGesamt"] = widerstand1zu1 / 1000 + v;
      } else {
        failed = true;
        failedMessage = "Keine geeignete Klammer für diese Eingaben! ";
      }
    }

    // Falls Eigenwiderstand beim Walm nicht groß genug gilt Walm = Trauf
    if (walmgleichtrauf) {
      result["WindlastKategorie1BefestigungWalm"] =
        result["WindlastKategorie1Befestigung"];
      result["WindlastKategorie1WiderstandWalm"] =
        result["WindlastKategorie1WiderstandKlammer"];
    }
    //console.log(result)
    if (!failed) return result;
    else return failedMessage;
  }

  /************************************************* DACHFLÄCHENBERECHNUNG *******************************************************/
  /**
   * @return Array mit Flächen für Kategorie 1,2,3,4 oder String mit Fehlermeldung (!Alle Werte nur für eine Dachfläche)
   * Kategorie 1: Ortgang
   * Kategorie 2: Innenbereich
   * Kategorie 3: Traufe
   * Kategorie 4: First
   */
  calculateDachflaechenSatteldach(
    dachneigung,
    laengeGiebel,
    laengeTraufe,
    gebHoehe
  ) {
    if (
      this.is_numeric(dachneigung) &&
      this.is_numeric(laengeGiebel) &&
      this.is_numeric(laengeTraufe) &&
      this.is_numeric(gebHoehe)
    ) {
      var ex;
      var ey;
      // Bestimmung ex
      if (laengeTraufe < 2 * gebHoehe) ex = laengeTraufe;
      else ex = 2 * gebHoehe;
      // Bestimmung ey
      if (laengeGiebel < 2 * gebHoehe) ey = laengeGiebel;
      else ey = 2 * gebHoehe;
      // ex/8 und ey/8
      var ex8 = ex / 8;
      var ey8 = ey / 8;
      ey8 = ey8 > 1.5 ? ey / 8 : 1.5;

      var dreieckB = laengeGiebel / 2;

      // Bestimmung x (Giebellänge von einer Dachseite)
      var x = dreieckB / Math.cos(this.deg2rad(dachneigung));
      var h = dreieckB * Math.sin(this.deg2rad(this.dachneigung)) / Math.sin(this.deg2rad(90));

      if (h + 1 > this.gebHoehe) {
        return "Die Traufkante muss mehr als 1m hoch sein!"
      }
      // Ortgangfläche
      var breiteKat1 = ey8;
      var laengeKat1 = x * 2;
      var flaecheKat1 = ey8 * x * 2;
      // Innenbereichfläche
      var breiteKat2 = x - ex8 * 2;
      var laengeKat2 = laengeTraufe - ey8 * 2;
      var flaecheKat2 = (x - ex8 * 2) * (laengeTraufe - ey8 * 2);
      // Trauffläche
      var breiteKat3 = ex8;
      var laengeKat3 = laengeTraufe - ey8 * 2;
      var flaecheKat3 = ex8 * (laengeTraufe - ey8 * 2);
      // Firstfläche
      var breiteKat4 = ex8;
      var laengeKat4 = laengeTraufe - ey8 * 2;
      var flaecheKat4 = ex8 * (laengeTraufe - ey8 * 2);
      //console.log(ex8 +" " +laengeTraufe +" "+ ey8*2)

      var dachFlaeche = x * laengeTraufe;

      return {
        FlaecheKat1: Math.round(flaecheKat1 * 2 * 10) / 10,
        FlaecheKat2: flaecheKat2 < 0 ? 0 : Math.round(flaecheKat2 * 2 * 10) / 10,
        FlaecheKat3: Math.round(flaecheKat3 * 2 * 10) / 10,
        FlaecheKat4: Math.round(flaecheKat4 * 2 * 10) / 10,
        FlaecheDach: Math.round(dachFlaeche * 2 * 10) / 10,
        BreiteKat1: Math.round(breiteKat1 * 10) / 10,
        LaengeKat1: Math.round(laengeKat1 * 10) / 10,
        BreiteKat2: breiteKat2 < 0 ? 0 : Math.round(breiteKat2 * 10) / 10,
        LaengeKat2: Math.round(laengeKat2 * 10) / 10,
        BreiteKat3: Math.round(breiteKat3 * 10) / 10,
        LaengeKat3: Math.round(laengeKat3 * 10) / 10,
        BreiteKat4: Math.round(breiteKat4 * 10) / 10,
        LaengeKat4: Math.round(laengeKat4 * 10) / 10
      };
    } else {
      return (
        "Unerlaubte eingabe bei Flaechenberechnung Satteldach" +
        dachneigung +
        " - " +
        laengeGiebel +
        " - " +
        laengeTraufe +
        " - " +
        gebHoehe +
        " "
      );
    }
  }

  /**
   * @return Array mit Flächen für Kategorie 1,2,3,4 oder String mit Fehlermeldung (!Alle Werte nur für eine Dachfläche)
   * Kategorie 1: Ortgang
   * Kategorie 2: Innenbereich
   * Kategorie 3: Traufe
   * Kategorie 4: First
   */
  calculateDachflaechenWalmdach(
    dachneigung,
    walmneigung,
    laengeKurzeTraufeWalm,
    laengeTraufe,
    gebHoehe
  ) {
    if (
      this.is_numeric(dachneigung) &&
      this.is_numeric(laengeKurzeTraufeWalm) &&
      this.is_numeric(laengeTraufe) &&
      this.is_numeric(gebHoehe) &&
      this.is_numeric(walmneigung)
    ) {
      var alpha = dachneigung;
      var beta = walmneigung;
      var breite = laengeKurzeTraufeWalm;
      var laenge = laengeTraufe;

      // Berechnung vom Dreieck unterm Trapez (Traufe)
      var hoeheT = Math.tan(this.deg2rad(alpha)) * (breite / 2);
      var cT = breite / 2 / Math.cos(this.deg2rad(alpha));

      if (hoeheT + 1 > gebHoehe)
        return "Die Traufkante muss mehr als 1m hoch sein!"

      // Berechnung vom Dreieck unterm Dreieck (Walm)
      var hoeheD = hoeheT;
      var alphaD = beta;
      var cD = hoeheD / Math.sin(this.deg2rad(alphaD));
      var bD = hoeheD / Math.tan(this.deg2rad(alphaD));

      // Berechnung vom Dreieck unter kurze Seite von Walmdreieck
      var bW = Math.sqrt(Math.pow(breite / 2, 2) + Math.pow(bD, 2));
      var hoeheW = hoeheT;
      var cW = Math.sqrt(Math.pow(hoeheW, 2) + Math.pow(bW, 2));

      // Ermittlung von ex (kleinere Wert von Trauflänge und 2mal Gebäudehöhe)
      var ex = laenge < 2 * gebHoehe ? laenge : 2 * gebHoehe;
      var ex8 = ex / 8;
      // Ermittlung von ey (kleinere Wert von Breite(Kurze Seite Walmdach) und 2mal Gebäudehöhe)
      var ey = breite < 2 * gebHoehe ? breite : 2 * gebHoehe;
      // Ermittlung von e (größere Wert von ex und ey) muss mindestens 1m sein
      var e = ex > ey ? ex : ey;
      var e8 = e / 8 >= 1 ? e / 8 : 1;

      // Berechnung Gratfläche (Parallelogramm, konvexes ebenes Viereck) (Kategorie 1)
      var flaecheGrat = e8 * cW;
      var flaecheKat1Grat = flaecheGrat * 2;
      var breiteKat1 = e8;
      var laengeKat1 = cW;

      // Berechnung Traufbereich Tr (Kategorie 3)
      var alphaTr = Math.asin(cT / cW);
      // Trauf-Trapezdreieck Boden
      var bDTr = ex8 / Math.tan(alphaTr);
      var aTr = laenge - 2 * (e8 / Math.sin(alphaTr));
      var cTr = aTr - 2 * bDTr;
      var flaecheTr = ((aTr + cTr) / 2) * ex8;
      var flaecheKat3 = flaecheTr;
      var breiteKat3 = ex8;
      var laengeKat3 = laenge - 2 * breiteKat1;

      // Berechnung Firstbereich F (Kategorie 4)
      var cF = laenge - 2 * bD - 2 * (e8 / Math.sin(alphaTr));
      var aF = cF + 2 * bDTr;
      var flaecheF = (((aF + cF) / 2) * ex8) / 2;
      var flaecheKat4 = flaecheF;
      var breiteKat4 = ex8;
      var laengeKat4 = (aF + cF) / 2;

      // Fläche der Walmseite (Dreieckfläche auf dem Dach) (Kategorie 1)
      var walmflaeche = (breite * cD) / 2;
      var flaecheKat1Walm = walmflaeche;
      // Fläche der Trapezfläche auf dem Dach
      var laengeOben = laenge - 2 * bD;
      // console.log("Laenge: " + laenge + ", bD: " + bD + ", cT:" + cT);
      // console.log("Laenge Oben: " + laengeOben);
      var trapezflaeche = ((parseInt(laengeOben) + parseInt(laenge)) / 2) * cT;

      // console.log("Trapezflaeche: " + trapezflaeche);

      // Fläche Innenbereich I (Kategorie 2)
      var flaecheI =
        trapezflaeche - flaecheKat1Grat - flaecheKat3 - flaecheKat4;
      var flaecheKat2 = flaecheI;
      var breiteKat2 = cW - breiteKat3 - breiteKat4;
      var laengeKat2 = flaecheKat2 / breiteKat2;

      // Fläche Dach (1 Trapez und 1 Dreiech)
      var dachFlaeche = trapezflaeche + walmflaeche;

      if (bD > laengeTraufe / 2) {
        return "Dieses Dach kann so nicht existieren! ";
      }

      return {
        FlaecheKat1Grat: Math.round(flaecheKat1Grat * 2 * 10) / 10,
        FlaecheKat1Walm: Math.round(flaecheKat1Walm * 2 * 10) / 10,
        FlaecheKat2: Math.round(flaecheKat2 * 2 * 10) / 10,
        FlaecheKat3: Math.round(flaecheKat3 * 2 * 10) / 10,
        FlaecheKat4: Math.round(flaecheKat4 * 2 * 10) / 10,
        FlaecheDach: Math.round(dachFlaeche * 2 * 10) / 10,
        EX8: ex8,
        E8: e8,
        BreiteKat1: Math.round(breiteKat1 * 10) / 10,
        LaengeKat1: Math.round(laengeKat1 * 10) / 10,
        BreiteKat2: Math.round(breiteKat2 * 10) / 10,
        LaengeKat2: Math.round(laengeKat2 * 10) / 10,
        BreiteKat3: Math.round(breiteKat3 * 10) / 10,
        LaengeKat3: Math.round(laengeKat3 * 10) / 10,
        BreiteKat4: Math.round(breiteKat4 * 10) / 10,
        LaengeKat4: Math.round(laengeKat4 * 10) / 10
      };
    } else {
      return (
        "Unerlaubte eingabe bei Flaechenberechnung Walmdach" +
        dachneigung +
        " - " +
        laengeKurzeTraufeWalm +
        " - " +
        laengeTraufe +
        " - " +
        gebHoehe +
        " - " +
        walmneigung +
        ""
      );
    }
  }

  /**
   * @return Array mit Flächen für Kategorie 1,2,3,4 oder String mit Fehlermeldung (!Alle Werte nur für eine Dachfläche)
   * Kategorie 1: Ortgang
   * Kategorie 2: Innenbereich
   * Kategorie 3: Traufe
   * Kategorie 4: First
   */
  calculateDachflaechenPultdach(
    dachneigung,
    laengeGiebel,
    laengeTraufe,
    gebHoehe
  ) {
    if (
      this.is_numeric(dachneigung) &&
      this.is_numeric(laengeGiebel) &&
      this.is_numeric(laengeTraufe) &&
      this.is_numeric(gebHoehe)
    ) {
      var ex;
      var ey;
      // Bestimmung ex
      if (laengeTraufe < 2 * gebHoehe) ex = laengeTraufe;
      else ex = 2 * gebHoehe;
      // Bestimmung ey
      if (laengeGiebel < 2 * gebHoehe) ey = laengeGiebel;
      else ey = 2 * gebHoehe;
      // ex/8 und ey/8
      var ex8 = ex / 8;
      var ey8 = ey / 8;
      ey8 = ey8 > 1.5 ? ey / 8 : 1.5;

      var dreieckB = laengeGiebel;

      // Bestimmung x (Giebellänge von einer Dachseite)
      var x = dreieckB / Math.cos(this.deg2rad(dachneigung));
      var h = dreieckB * Math.sin(this.deg2rad(this.dachneigung)) / Math.sin(this.deg2rad(90));

      if (h + 1 > this.gebHoehe) {
        return "Die Traufkante muss mehr als 1m hoch sein!"
      }


      // Ortgangfläche
      var breiteKat1 = ey8;
      var laengeKat1 = x * 2;
      var flaecheKat1 = ey8 * x * 2;
      // Innenbereichfläche
      var breiteKat2 = x - ex8 * 2;
      var laengeKat2 = laengeTraufe - ey8 * 2;
      var flaecheKat2 = (x - ex8 * 2) * (laengeTraufe - ey8 * 2);
      // Trauffläche
      var breiteKat3 = ey8;
      var laengeKat3 = laengeTraufe - ey8 * 2;
      var flaecheKat3 = ex8 * (laengeTraufe - ey8 * 2);
      // Firstfläche
      var breiteKat4 = ey8;
      var laengeKat4 = laengeTraufe - ey8 * 2;
      var flaecheKat4 = ex8 * (laengeTraufe - ey8 * 2);

      var dachFlaeche = x * laengeTraufe;

      return {
        FlaecheKat1: Math.round(flaecheKat1 * 10) / 10,
        FlaecheKat2: Math.round(flaecheKat2 * 10) / 10,
        FlaecheKat3: Math.round(flaecheKat3 * 10) / 10,
        FlaecheKat4: Math.round(flaecheKat4 * 10) / 10,
        FlaecheDach: Math.round(dachFlaeche * 10) / 10,
        BreiteKat1: Math.round(breiteKat1 * 10) / 10,
        LaengeKat1: Math.round(laengeKat1 * 10) / 10,
        BreiteKat2: Math.round(breiteKat2 * 10) / 10,
        LaengeKat2: Math.round(laengeKat2 * 10) / 10,
        BreiteKat3: Math.round(breiteKat3 * 10) / 10,
        LaengeKat3: Math.round(laengeKat3 * 10) / 10,
        BreiteKat4: Math.round(breiteKat4 * 10) / 10,
        LaengeKat4: Math.round(laengeKat4 * 10) / 10
      };
    } else {
      return (
        "Unerlaubte eingabe bei Flaechenberechnung Pultdach" +
        dachneigung +
        " - " +
        laengeGiebel +
        " - " +
        laengeTraufe +
        " - " +
        gebHoehe +
        " - "
      );
    }
  }

  /************************************************* WERTETABELLEN *******************************************************/

  /**
   * @param dachneigung
   * @param kategorie = Zahl der Kategorie für den Dachbereich
   * Kategorie 1: Ortgang, Grat, Walm, Kehle
   * Kategorie 2: Innenbereich
   * Kategorie 3: Traufe
   * Kategorie 4: First
   */
  calculateAussendruckbeiwert(dachneigung, kategorie) {
    var failed = false;
    var failedMessage = "";
    var aussendruck = 0;
    if (kategorie == 1) {
      //KATEGORIE 1
      if (dachneigung >= 7 && dachneigung < 15) {
        aussendruck = -2.1;
      } else if (dachneigung >= 15 && dachneigung < 30) {
        aussendruck = -2.0;
      } else if (dachneigung >= 30 && dachneigung < 45) {
        aussendruck = -2.0;
      } else if (dachneigung >= 45 && dachneigung < 60) {
        aussendruck = -2.0;
      } else if (dachneigung >= 60 && dachneigung < 65) {
        aussendruck = -2.0;
      } else if (dachneigung == 65) {
        aussendruck = -2.0;
      } else {
        failed = true;
        failedMessage = "Unerlaubte Eingabe bei Dachneigung ";
      }
    } else if (kategorie == 2) {
      //KATEGORIE 2
      if (dachneigung >= 7 && dachneigung < 15) {
        aussendruck = -0.6;
      } else if (dachneigung >= 15 && dachneigung < 30) {
        aussendruck = -0.5;
      } else if (dachneigung >= 30 && dachneigung < 45) {
        aussendruck = -0.5;
      } else if (dachneigung >= 45 && dachneigung < 60) {
        aussendruck = -0.5;
      } else if (dachneigung >= 60 && dachneigung < 65) {
        aussendruck = -0.5;
      } else if (dachneigung == 65) {
        aussendruck = -0.5;
      } else {
        failed = true;
        failedMessage = "Unerlaubte Eingabe bei Dachneigung ";
      }
    } else if (kategorie == 3) {
      //KATEGORIE 3
      if (dachneigung >= 7 && dachneigung < 15) {
        aussendruck = -1.7;
      } else if (dachneigung >= 15 && dachneigung < 30) {
        aussendruck = -1.5;
      } else if (dachneigung >= 30 && dachneigung < 45) {
        aussendruck = -1.5;
      } else if (dachneigung >= 45 && dachneigung < 60) {
        aussendruck = 0.7;
      } else if (dachneigung >= 60 && dachneigung < 65) {
        aussendruck = 0.7;
      } else if (dachneigung == 65) {
        aussendruck = 0.74;
      } else {
        failed = true;
        failedMessage = "Unerlaubte Eingabe bei Dachneigung ";
      }
    } else if (kategorie == 4) {
      //KATEGORIE 4
      if (dachneigung >= 7 && dachneigung < 15) {
        aussendruck = -0.8;
      } else if (dachneigung >= 15 && dachneigung < 30) {
        aussendruck = -1.5;
      } else if (dachneigung >= 30 && dachneigung < 45) {
        aussendruck = -0.5;
      } else if (dachneigung >= 45 && dachneigung < 60) {
        aussendruck = -0.5;
      } else if (dachneigung >= 60 && dachneigung < 65) {
        aussendruck = -0.5;
      } else if (dachneigung == 65) {
        aussendruck = -0.5;
      } else {
        failed = true;
        failedMessage = "Unerlaubte Eingabe bei Dachneigung ";
      }
    }
    // console.log(kategorie + " " + aussendruck);

    if (!failed) return aussendruck;
    else
      return {
        message: failedMessage
      };
  }

  /**
   * @param dachneigung
   * @param kategorie = Zahl der Kategorie für den Dachbereich
   * Kategorie 1: Ortgang, Grat, Walm, Kehle
   * Kategorie 2: Innenbereich
   * Kategorie 3: Traufe
   * Kategorie 4: First
   */
  calculateAussendruckbeiwertPult(dachneigung, kategorie) {
    var failed = false;
    var failedMessage = "";
    var aussendruck = 0;
    if (kategorie == 1) {
      //KATEGORIE 1
      if (dachneigung >= 7 && dachneigung < 15) {
        aussendruck = -2.7;
      } else if (dachneigung >= 15 && dachneigung < 30) {
        aussendruck = -2.9;
      } else if (dachneigung >= 30 && dachneigung < 45) {
        aussendruck = -2.9;
      } else if (dachneigung >= 45 && dachneigung < 60) {
        aussendruck = -2.4;
      } else if (dachneigung >= 60 && dachneigung < 65) {
        aussendruck = -2.0;
      } else if (dachneigung == 65) {
        aussendruck = -2.0;
      } else {
        failed = true;
        failedMessage = "Unerlaubte Eingabe bei Dachneigung ";
      }
    } else if (kategorie == 2) {
      //KATEGORIE 2
      if (dachneigung >= 7 && dachneigung < 15) {
        aussendruck = -1.2;
      } else if (dachneigung >= 15 && dachneigung < 30) {
        aussendruck = -1.2;
      } else if (dachneigung >= 30 && dachneigung < 45) {
        aussendruck = -1.2;
      } else if (dachneigung >= 45 && dachneigung < 60) {
        aussendruck = -1.2;
      } else if (dachneigung >= 60 && dachneigung < 65) {
        aussendruck = -1.2;
      } else if (dachneigung == 65) {
        aussendruck = -0.5;
      } else {
        failed = true;
        failedMessage = "Unerlaubte Eingabe bei Dachneigung ";
      }
    } else if (kategorie == 3) {
      //KATEGORIE 3
      if (dachneigung >= 7 && dachneigung < 15) {
        aussendruck = -1.7;
      } else if (dachneigung >= 15 && dachneigung < 30) {
        aussendruck = -1.5;
      } else if (dachneigung >= 30 && dachneigung < 45) {
        aussendruck = -1.5;
      } else if (dachneigung >= 45 && dachneigung < 60) {
        aussendruck = 0.7;
      } else if (dachneigung >= 60 && dachneigung < 65) {
        aussendruck = 0.7;
      } else if (dachneigung == 65) {
        aussendruck = 0.8;
      } else {
        failed = true;
        failedMessage = "Unerlaubte Eingabe bei Dachneigung ";
      }
    } else if (kategorie == 4) {
      //KATEGORIE 4
      if (dachneigung >= 7 && dachneigung < 15) {
        aussendruck = -2.0;
      } else if (dachneigung >= 15 && dachneigung < 30) {
        aussendruck = -2.0;
      } else if (dachneigung >= 30 && dachneigung < 45) {
        aussendruck = -1.5;
      } else if (dachneigung >= 45 && dachneigung < 60) {
        aussendruck = -0.5;
      } else if (dachneigung >= 60 && dachneigung < 65) {
        aussendruck = -0.5;
      } else if (dachneigung == 65) {
        aussendruck = -0.5;
      } else {
        failed = true;
        failedMessage = "Unerlaubte Eingabe bei Dachneigung ";
      }
    }
    if (!failed) return aussendruck;
    else
      return {
        message: failedMessage
      };
  }
  /**
   * @param int Windzone - Windzone des Standortes (1-4)
   * @param float gebHoehe - Gebäudehöhe
   * @param string geoLage - Geografische Lage des Standortes (Binnenland / Kuestenland)
   */
  calculateGeschwindigkeitsdruck(windzone, gebHoehe, geoLage) {
    // console.log(windzone + " " + gebHoehe + " " + geoLage);
    var failed = false;
    var failedMessage = "";
    var geschDruck = 0;

    if (windzone == 1) {
      // WINDZONE 1
      if (geoLage == "Binnenland") {
        if (gebHoehe <= 10) {
          geschDruck = 0.5;
        } else if (gebHoehe > 10 && gebHoehe <= 18) {
          geschDruck = 0.65;
        } else if (gebHoehe > 18 && gebHoehe <= 25) {
          geschDruck = 0.75;
        } else {
          failed = true;
          failedMessage += "Unerlaubte Eingabe bei der Gebäudehöhe ";
        }
      } else {
        failed = true;
        failedMessage += "Windzone 1 befindet sich ausschließlich im Binnenland";
      }
    } else if (windzone == 2) {
      // WINDZONE 2
      if (geoLage == "Binnenland") {
        if (gebHoehe <= 10) {
          geschDruck = 0.65;
        } else if (gebHoehe > 10 && gebHoehe <= 18) {
          geschDruck = 0.8;
        } else if (gebHoehe > 18 && gebHoehe <= 25) {
          geschDruck = 0.9;
        } else {
          failed = true;
          failedMessage += "Unerlaubte Eingabe bei der Gebäudehöhe ";
        }
      } else if (geoLage == "Kuestenland") {
        if (gebHoehe <= 10) {
          geschDruck = 0.85;
        } else if (gebHoehe > 10 && gebHoehe <= 18) {
          geschDruck = 1;
        } else if (gebHoehe > 18 && gebHoehe <= 25) {
          geschDruck = 1.1;
        } else {
          failed = true;
          failedMessage += "Unerlaubte Eingabe bei der Gebäudehöhe ";
        }
      } else {
        failed = true;
        failedMessage += "Unerlaubte Eingabe bei der geografischen Lage ";
      }
    } else if (windzone == 3) {
      // WINDZONE 3
      if (geoLage == "Binnenland") {
        if (gebHoehe <= 10) {
          geschDruck = 0.8;
        } else if (gebHoehe > 10 && gebHoehe <= 18) {
          geschDruck = 0.95;
        } else if (gebHoehe > 18 && gebHoehe <= 25) {
          geschDruck = 1.1;
        } else {
          failed = true;
          failedMessage += "Unerlaubte Eingabe bei der Gebäudehöhe ";
        }
      } else if (geoLage == "Kuestenland") {
        if (gebHoehe <= 10) {
          geschDruck = 1.05;
        } else if (gebHoehe > 10 && gebHoehe <= 18) {
          geschDruck = 1.2;
        } else if (gebHoehe > 18 && gebHoehe <= 25) {
          geschDruck = 1.3;
        } else {
          failed = true;
          failedMessage += "Unerlaubte Eingabe bei der Gebäudehöhe ";
        }
      } else {
        failed = true;
        failedMessage += "Unerlaubte Eingabe bei der geografischen Lage ";
      }
    } else if (windzone == 4) {
      // WINDZONE 4
      if (geoLage == "Binnenland") {
        if (gebHoehe <= 10) {
          geschDruck = 0.95;
        } else if (gebHoehe > 10 && gebHoehe <= 18) {
          geschDruck = 1.15;
        } else if (gebHoehe > 18 && gebHoehe <= 25) {
          geschDruck = 1.3;
        } else {
          failed = true;
          failedMessage += "Unerlaubte Eingabe bei der Gebäudehöhe ";
        }
      } else if (geoLage == "Kuestenland") {
        if (gebHoehe <= 10) {
          geschDruck = 1.25;
        } else if (gebHoehe > 10 && gebHoehe <= 18) {
          geschDruck = 1.4;
        } else if (gebHoehe > 18 && gebHoehe <= 25) {
          geschDruck = 1.55;
        } else {
          failed = true;
          failedMessage += "Unerlaubte Eingabe bei der Gebäudehöhe ";
        }
      } else {
        failed = true;
        failedMessage += "Unerlaubte Eingabe bei der geografischen Lage ";
      }
    } else {
      failed = true;
      failedMessage += "Unerlaubte Eingabe bei der Windzone ";
    } //end else ifs windzone

    if (!failed) return geschDruck;
    else
      return {
        message: failedMessage
      };
  }

  /**
   * Überprüft ob ein Array negativwerte enthält:
   * Enthält Negativwerte: return true
   * Enthät keine Negativwerte: return false
   *
   * @param Array Array mit Werten
   * @return boolean - true: Negativwerte; false: keine Negativwerte
   */
  checkForNegatives(array) {
    for (var ae in array) {
      if (this.is_numeric(ae) && ae < 0) return true;
    }

    return false;
  }

  /**
   * @param String Errormessage
   * @return Array ErrorArray mit Fehler = true und Fehlermeldung = Message
   */
  getErrorMessage(message) {
    return {
      Error: true,
      Errormessage: message
    };
  }

  /**
   *
   * @param {float} radians takes a value in radians and converts it to degrees
   * @return {float} degree value of parameter
   */
  rad2deg(radians) {
    var pi = Math.PI;
    return radians * (180 / pi);
  }

  /**
   *
   * @param {float} degrees takes a value in degrees and converts it to radians
   * @return {float} radian value of parameter
   */
  deg2rad(degrees) {
    var pi = Math.PI;
    return degrees / (180 / pi);
  }

  /**
   * Checks if variable is numeric
   * @param {var} value
   */
  is_numeric(value) {
    return !isNaN(value);
  }

  array_key_exists(key, array) {
    return key in array;
  }

  isArray(array) {
    if (typeof array == "object") return true;
    else return false;
  }
}